import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { triggerExternalLinkPopup } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './main-categories-item.scss.js';

class MainCategoriesItem extends s {
    constructor() {
        super(...arguments);
        this.query = '(max-width: 1365px)';
        this.isDesktop = false;
        this.externalLinkPopup = null;
        this.handleFocusEvents = () => {
            var _a, _b, _c;
            const cta = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.cta')) === null || _b === void 0 ? void 0 : _b.children[0];
            const parentItem = (_c = cta === null || cta === void 0 ? void 0 : cta.parentNode) === null || _c === void 0 ? void 0 : _c.parentNode;
            cta === null || cta === void 0 ? void 0 : cta.addEventListener('focus', () => {
                parentItem.classList.add('selected');
            });
            cta === null || cta === void 0 ? void 0 : cta.addEventListener('focusout', () => {
                parentItem.classList.remove('selected');
            });
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', () => {
            var _a;
            const url = (_a = this.querySelector('[slot="cta"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('href');
            if (url)
                window.location.href = url;
        });
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.connectedCallback);
        super.disconnectedCallback();
    }
    handleMediaQuery(event) {
        this.isDesktop = !event.detail.value;
    }
    renderCTA() {
        return this.ctaText && this.href
            ? $ `<p @click="${(e) => triggerExternalLinkPopup(e, this)}" @keyup="${(e) => triggerExternalLinkPopup(e, this)}" class="cta">${this.ctaText}</p>`
            : null;
    }
    firstUpdated() {
        var _a;
        const item = this.shadowRoot.querySelector('.item');
        if (this.classList.contains('divider'))
            item === null || item === void 0 ? void 0 : item.classList.add('divider', `item-${this.getAttribute('index')}`);
        (_a = document.querySelector('.fallback-link')) === null || _a === void 0 ? void 0 : _a.remove();
        const modal = document.querySelector('cvt-modal[popupid="external-link"]');
        if (!modal)
            return;
        this.externalLinkPopup = modal.querySelector('external-link');
        this.handleFocusEvents();
    }
    render() {
        return $ `<a href="${this.href}" @click="${(e) => triggerExternalLinkPopup(e, this)}" class="item ${this.href ? '' : 'no-href'} ${this.rtl || isRTL() ? 'rtl' : ''}"><div class="image-wrapper ${this.isWide ? 'wide' : ''}"><slot name="image"></slot><div class="overlay"></div></div><div class="text-content"><slot @click="${() => this.click()}" @keyup="${() => this.click()}" name="title"></slot><slot @click="${() => this.click()}" @keyup="${() => this.click()}" name="text" class="body"></slot>${this.renderCTA()}</div></a><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
MainCategoriesItem.styles = css_248z;
__decorate([
    e({ type: Boolean })
], MainCategoriesItem.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], MainCategoriesItem.prototype, "isWide", void 0);
__decorate([
    e({ type: String })
], MainCategoriesItem.prototype, "href", void 0);
__decorate([
    e({ type: String })
], MainCategoriesItem.prototype, "ctaText", void 0);
__decorate([
    t()
], MainCategoriesItem.prototype, "isDesktop", void 0);
__decorate([
    t()
], MainCategoriesItem.prototype, "externalLinkPopup", void 0);
customElements.define('main-categories-item', MainCategoriesItem);

export { MainCategoriesItem };
